import React from 'react';

import { PaidInvoiceRow } from '@project/components';
import { PaidInvoice } from '@project/types';

type Props = {
  className?: string;
  invoice: PaidInvoice;
};

export const PaidInvoiceSummary: React.FC<Props> = ({ className, invoice }) => {
  return (
    <PaidInvoiceRow
      key={invoice.id}
      className={`my-2 ${className}`}
      amountPaid={invoice.amountPaid}
      invoiceAmount={invoice.subtotal}
      invoiceNumber={invoice.invoiceNumber}
      paymentType={invoice.paymentType}
      invoiceId={invoice.id}
    />
  );
};
